
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Label } from "@/components/ui/label";

interface RoleFilterProps {
  roleFilter: string;
  onRoleChange: (value: string) => void;
}

export function RoleFilter({ roleFilter, onRoleChange }: RoleFilterProps) {
  return (
    <div>
      <Label className="text-foreground">Job Role</Label>
      <Select value={roleFilter} onValueChange={onRoleChange}>
        <SelectTrigger className="bg-background border-border text-foreground rounded-sm">
          <SelectValue placeholder="Select role" className="text-muted-foreground" />
        </SelectTrigger>
        <SelectContent className="bg-card border-border rounded-sm">
          <SelectItem value="all" className="text-foreground hover:bg-accent">All roles</SelectItem>
          <SelectItem value="engineer" className="text-foreground hover:bg-accent">Engineer</SelectItem>
          <SelectItem value="designer" className="text-foreground hover:bg-accent">Designer</SelectItem>
          <SelectItem value="product" className="text-foreground hover:bg-accent">Product Manager</SelectItem>
          <SelectItem value="marketing" className="text-foreground hover:bg-accent">Marketing</SelectItem>
          <SelectItem value="sales" className="text-foreground hover:bg-accent">Sales</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
}
